import { Flex } from "antd";
import { useTranslation } from "react-i18next";
import { BookmarkTabsImproved } from "@/shared/Components";
import { useContactsTabs } from "@/entities/contacts-tabs/model";
import { ContactTabsExtra } from "@/entities/contact-tabs-extra";
import { NoContactsPage } from "@/pages/ContactsPage/Components/NoContactsPage";
import type { ContactsTabsProps } from "@/entities/contacts-tabs/model";
import styles from "./styles.module.scss";

export const ContactTabsContentDesktop = ({
  selectedPersonId,
  setSelectedPersonId,
}: ContactsTabsProps) => {
  const { t } = useTranslation();

  const { state, methods } = useContactsTabs(selectedPersonId);

  const { activeTab, isEditMode, disabledKeys, tabs } = state;
  const { handleTabChange, handleEditMode } = methods;

  if (!selectedPersonId) {
    return (
      <Flex justify="center" align="center" className={styles.root}>
        <NoContactsPage message={t("contactsPage.noSelected")} />
      </Flex>
    );
  }

  return (
    <Flex className={styles.root}>
      <BookmarkTabsImproved
        tabs={tabs}
        activeKey={activeTab}
        onTabChange={handleTabChange}
        disabledKeys={disabledKeys}
        extraContent={
          <ContactTabsExtra
            selectedPersonId={selectedPersonId}
            isEditMode={isEditMode}
            handleEditMode={handleEditMode}
            activeTab={activeTab}
            setSelectedPersonId={setSelectedPersonId}
          />
        }
        isContactsPage
      />
    </Flex>
  );
};
